<template>
    <div>
        <button type="button" class="btn btn-secondary btn-sm float-right ml-2 mb-2" @click="refresh()"><i class="fas fa-sync-alt"></i> Refresh</button>
        <div v-if="loading && loading == true" class="row align-items-center justify-content-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <!--<data-list v-else
        :dataCols="dataCols"
        :dataListItems="dataList"
        :tableClass="'table table-striped table-sm'" />-->

        <table v-else class="table">
            <thead>
                <tr>
                    <th scope="col">Gadget</th>
                    <th scope="col">Currency</th>
                    <th scope="col">Amount</th>
                    <th scope="col">Date Calculated</th>
                    <th scope="col">Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(itm, idx) in dataList" :key="'claimgadgetexcesslist_' + idx"
                    :class="selectedRowIndex == idx ? 'table-primary' : ''"
                    :style="'cursor: pointer'"
                    @click="handleRowClick(idx, itm)">
                    <td>{{itm.displayLabel}}</td>
                    <td>{{itm.currencyCode}}</td>
                    <td>{{itm.excess}}</td>
                    <td>{{itm.dateCalculatedAsLocalTime}}</td>
                    <td>
                        <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" no-caret :boundary="'window'">
                            <template v-slot:button-content>
                                <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                                <span class="sr-only">Actions menu</span>
                            </template>
                            <b-dropdown-item href="javascript:void(0)"  @click="handleCreateClaimPaymentClick(idx,itm)" :disabled="itm.claimPaymentId > 0 || !claimPaymentsEnabled">
                                <i v-if="false" :class="iconClass"></i> Create Claim Payment
                            </b-dropdown-item>
                            <b-dropdown-item href="javascript:void(0)" @click="handleDeleteClick(idx,itm)" :disabled="(itm.cardPaymentId > 0 || itm.claimPaymentId > 0) || !claimPaymentsEnabled">
                                <i v-if="false" :class="iconClass"></i> Delete
                            </b-dropdown-item>
                        </b-dropdown>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
    import axios from 'axios'
    import { API_BASE_URL } from '../globalVar'

    import DataList from '@/components/DataList.vue'
    //import { excessCalculationCols } from '@/ui.config/cols/excessCalculationCols'

    import { mapActions,mapGetters } from 'vuex'

    export default {
        name: 'ClaimExcessCalcList',
        components: {
            DataList
        },
        props: {
            claimId: {
                type: Number,
                required: true
            },
            load: Boolean
        },
        data: () => {
            return {
                loading: false,
                selectedRowIndex: null,
                //calculations: []
            }
        },
        watch: {
            load: async function (newVal, oldVal) {
                if (newVal == true) {
                    await this.getForClaim(this.claimId)
                }
            }
        },
        computed: {
            ...mapGetters({
                claimPaymentsEnabled: 'appSettings/claimPaymentsEnabled'
            }),
            selectedClaim() {
                return this.$store.getters.selectedClaim
            },
            dataCols() {
                return excessCalculationCols
            },
            calculations() {
                if (this.selectedClaim && this.selectedClaim.excessCalculations) {
                    return this.selectedClaim.excessCalculations
                }
                return null
            },
            dataList() {
                if (this.calculations) {
                    return this.calculations.map(o => ({ ...o, displayLabel: `${o.makeLabel} - ${o.modelLabel} - ${o.serialNo || o.imeiNo}` }))
                } else {
                    return []
                }
            }
        },
        methods: {
            ...mapActions({
                fetchData: 'fetchExcessCalculationsClaim'
            }),
            async getForClaim(claimId) {
                //console.log('PING2')
                if (claimId && !isNaN(claimId)) {
                    //console.log('PING3')
                    this.loading = true
                    try {
                        const response = await this.fetchData(claimId)
                            //await axios.get('/api/admin/v1/claims/getexcesscalculations/' + claimId)
                        //console.log("-r : ", response)
                        //const { data } = response
                        //this.calculations = data
                    } catch (error) {
                        console.error(error)
                    } finally {
                        this.loading = false
                        this.$emit('finished-loading')
                    }
                }
            },
            async refresh() {
                await this.getForClaim(this.claimId)
            },
            handleRowClick(rowIndex, item) {
                this.selectedRowIndex = rowIndex
            },
            async handleCreateClaimPaymentClick(idx, itm) {
                let { claimId } = this.selectedClaim
                let { id, gadgetId } = itm
                
                let payload = {
                    claimId,
                    sourceEntityId: id,
                    sourceEntityType: gadgetId ? 2 : 1
                }

                //console.log('-p : ', payload)
                this.loading = true
                try {
                    const response = await axios.post('/api/admin/v1/finance/createclaimpayment/', payload)
                    //console.log("-r : ", response)
                    //const { data } = response
                    //if (data) {
                        
                    //}

                } catch (error) {
                    console.error(error)
                } finally { this.loading = false }
            }
        }
    }
</script>
